import { render, staticRenderFns } from "./Comp61t2.vue?vue&type=template&id=8334ffe4&scoped=true&"
import script from "./Comp61t2.vue?vue&type=script&lang=js&"
export * from "./Comp61t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp61t2.vue?vue&type=style&index=0&id=8334ffe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8334ffe4",
  null
  
)

export default component.exports